import React from 'react'
import update from 'immutability-helper'

import { lease } from '../../core/controllers/Lease'
import { modal } from '../../core/utilities/modal'

export default class LeaseInvoices extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            leaseId: props.leaseId,
            invoiceData: [],
        }
    }

    componentDidMount() {
        var self = this;
        lease.getLeaseLineItems(this.state.leaseId, function(response) {
            const invoices = response.data.map((item, itemIndex) => {
                item['amount'] = item['amount'] / 100;
                return item;
            });

            self.setState({
                invoiceData: invoices
            });
        })
    }

    addLineItem() {
        this.setState({
            invoiceData: update(this.state.invoiceData, {
                $push: [{
                    title: "",
                    type: "charge",
                    amount: 0
                }]
            })
        })
    }

    handleChangeLineItemTitle(index, e) {
        var inputValue = e.target.value;

        this.setState(state => {
            const invoiceData = state.invoiceData.map((item, itemIndex) => {
                if (itemIndex == index) {
                    item["title"] = inputValue
                    return item
                } else {
                    return item
                }
            })

            return {
                invoiceData
            }
        })
    }

    handleChangeLineItemType(index, e) {
        var inputValue = e.target.value;

        this.setState(state => {
            const invoiceData = state.invoiceData.map((item, itemIndex) => {
                if (itemIndex == index) {
                    item["type"] = inputValue
                    return item
                } else {
                    return item
                }
            })

            return {
                invoiceData
            }
        })
    }

    handleChangeLineItemAmount(index, e) {
        var inputValue = e.target.value;

        this.setState(state => {
            const invoiceData = state.invoiceData.map((item, itemIndex) => {
                if (itemIndex == index) {
                    item["amount"] = inputValue
                    return item
                } else {
                    return item
                }
            })

            return {
                invoiceData
            }
        })
    }

    handleRemoveLineItem(index) {
        var newInvoiceData = this.state.invoiceData;
        var item           = this.state.invoiceData[index];
        newInvoiceData.splice(index, 1)

        if (typeof item.invoice_line_item_id !== 'undefined') {
            lease.deleteLeaseLineItem(this.state.leaseId, item.invoice_line_item_id, function(response) {
                modal.showInfo("Line item have been successfully removed!", "success", "top", "center");
            });
        }

        this.setState({
            invoiceData: newInvoiceData
        });
    }

    validate() {
        const invoiceData = this.state.invoiceData;

        for (var i = 0; i < invoiceData.length; i++) {
            if (invoiceData[i]["title"] == "") {
                modal.showInfo("Your line item #" + (i+1) + " does not have a title.", "warning", "top", "center");
                return false
            } else if (invoiceData[i]["amount"] <= 0) {
                modal.showInfo("Your line item #" + (i+1) + " does not have an amount.", "warning", "top", "center");
                return false
            } else if (isNaN(invoiceData[i]["amount"])) {
                modal.showInfo("The amount of your line item #" + (i+1) + " is not a valid number.", "warning", "top", "center");
                return false
            }
        }

        return true
    }

    onSaveLeaseInvoices() {
        if (!this.validate()) {
            return false;
        }

        if (this.state.invoiceData.length > 0) {
            lease.saveLeaseLineItems(this.state.leaseId, this.state.invoiceData, function(response) {
                modal.showInfo("Your lease invoice items have been successfully added!", "success", "top", "center");
            })
        }

        return true
    }

    render() {
        var self = this;

        const invoicingItems = this.state.invoiceData.map(function(item, index) {
            return (
                <div key={index} class="col-md-12 col-sm-12 col-xs-12" style={{textAlign: "center", paddingBottom: 0}}>
                    <span class="tenant-charge-sentence">
                        Item:
                    </span>
                    <span class="tenant-charge-sentence">
                        This is for
                    </span>
                    <span class="tenant-charge-sentence">
                        <div class="form-group has-feedback">
                            <input type="text" class="form-control text-underline" value={item.title} onChange={self.handleChangeLineItemTitle.bind(self, index)} placeholder="Title"/>
                        </div>
                    </span>
                    <span class="tenant-charge-sentence">
                        for a
                    </span>
                    <span class="tenant-charge-sentence">
                        <select class="form-control text-underline" value={item.type} onChange={self.handleChangeLineItemType.bind(self, index)}>
                            <option key="charge" value="0">charge</option>
                            <option key="credit" value="1">credit</option>
                        </select>
                    </span>
                    <span class="tenant-charge-sentence">
                        of
                    </span>
                    <span class="tenant-charge-sentence">
                        <div class="form-group has-feedback">
                            <input type="text" class="form-control input-group-dollar-addon text-underline" value={item.amount} onChange={self.handleChangeLineItemAmount.bind(self, index)} placeholder="Amount" style={{paddingLeft: "35px", textAlign: 'left'}}/>
                            <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                        </div>
                    </span>
                    <span class="tenant-charge-sentence">
                        every month.
                    </span>
                    <span class="tenant-charge-sentence">
                        <div title={"Remove this line item from the list"} onClick={self.handleRemoveLineItem.bind(self, index)}><i class="fa fa-close removeTenantIcon"/></div>
                    </span>
                </div>
            )
        })

        return (
            <div class="card">
                <div class="header">
                    <h4 class="title">Invoice Items</h4>
                    <p class="category">List of charges and credits for this lease</p>
                </div>
                <br />
                <div class="content">
                    <div class="row">
                        { invoicingItems.length == 0 ? (
                            <div class="col-md-12"><p>No invoice items found.</p></div>
                        ) : (
                            invoicingItems
                        )}
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="col-md-12 col-sm-6 col-xs-12">
                                <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.addLineItem.bind(this)}>
                                    Add Item
                                </button>
                                { invoicingItems.length > 0 && (
                                <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-warning btn-fill pull-right" autoComplete="off" onClick={this.onSaveLeaseInvoices.bind(this)}>
                                    Save
                                </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// app/components/Leases/LeaseInvoices.jsx